require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-chris-holt-project-manager-turned-principal-ux-engineering-manager.json") })
        }
      }, "path---blog-meet-chris-holt-project-manager-turned-principal-ux-engineering-manager");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-chris-holt-project-manager-turned-principal-ux-engineering-manager!./.cache/json/blog-meet-chris-holt-project-manager-turned-principal-ux-engineering-manager.json
// module id = 957
// module chunks = 231608221292675